import { whatsapp } from '../../setup/settings/index';

export default function WhatsAppShared() {

  const whatsAppShared = () => {

    let locationPath = window.location.href;
    let urlWhatApp = 'https://wa.me/send?text=' + locationPath;
    window.open(urlWhatApp, '_blank');
  };

  return (
    <>
      {whatsapp.whatsAppSharedEnabled ?
        <div className="wspchatSticky-btn" onClick={whatsAppShared}>
          <div className="wspchatSticky-text">Share</div>
          <img src="https://cdn.shopify.com/s/files/1/0622/8577/5024/files/1.png?v=1665670344" alt="WhatsApp" title="WhatsApp" />
        </div>
        : ""
      }
    </>
  );
}